import dayjs from 'dayjs';

import { Schema } from '../types';

export enum RuleKey {
  REQUIRED_IF = 'required_if',
  SHOW_IF = 'show_if',
  GREATER_THAN = 'gte',
  AFTER_OR_EQUAL = 'after_or_equal',
  BEFORE_OR_EQUAL = 'before_or_equal',
  AFTER = 'after',
  BEFORE = 'before',
}

type RuleHandler = (
  ruleValue: Nullable<string>,
  schema: Schema,
  fieldName: string,
  watchedValues: Record<string, any>,
) => boolean;

export const ruleHandlers: Record<RuleKey, RuleHandler> = {
  [RuleKey.REQUIRED_IF]: (ruleValue, schema, fieldName, watchedValues) => {
    if (schema.required?.includes(fieldName)) return true;
    if (!ruleValue) return false;
    const [conditionFieldName, conditionValue] = ruleValue.split(',');
    if (!conditionFieldName || !conditionValue) return false;
    return watchedValues[conditionFieldName]?.toString() === conditionValue;
  },
  [RuleKey.SHOW_IF]: (ruleValue, _schema, _fieldName, watchedValues) => {
    if (!ruleValue) return true;
    const [conditionFieldName, conditionValue] = ruleValue.split(',');
    if (!conditionFieldName || !conditionValue) return true;
    return watchedValues[conditionFieldName]?.toString() === conditionValue;
  },
  [RuleKey.GREATER_THAN]: (ruleValue, _schema, fieldName, watchedValues) => {
    if (!ruleValue) return true;
    const compareField = ruleValue as string;
    if (watchedValues[fieldName] == null || watchedValues[compareField] == null) return true;
    return Number(watchedValues[fieldName]) >= Number(watchedValues[compareField]);
  },
  [RuleKey.AFTER_OR_EQUAL]: (ruleValue, _schema, fieldName, watchedValues) => {
    if (!ruleValue) return true;
    const compareField = ruleValue as string;
    if (!watchedValues[fieldName] || !watchedValues[compareField]) return true;
    return dayjs(watchedValues[fieldName]).isSameOrAfter(dayjs(watchedValues[compareField]), 'day');
  },
  [RuleKey.BEFORE_OR_EQUAL]: (ruleValue, _schema, fieldName, watchedValues) => {
    if (!ruleValue) return true;
    const compareField = ruleValue as string;
    if (!watchedValues[fieldName] || !watchedValues[compareField]) return true;
    return dayjs(watchedValues[fieldName]).isSameOrBefore(dayjs(watchedValues[compareField]), 'day');
  },
  [RuleKey.AFTER]: (ruleValue, _schema, fieldName, watchedValues) => {
    if (!ruleValue) return true;
    const compareField = ruleValue as string;
    if (!watchedValues[fieldName] || !watchedValues[compareField]) return true;
    return dayjs(watchedValues[fieldName]).isAfter(dayjs(watchedValues[compareField]), 'day');
  },
  [RuleKey.BEFORE]: (ruleValue, _schema, fieldName, watchedValues) => {
    if (!ruleValue) return true;
    const compareField = ruleValue as string;
    if (!watchedValues[fieldName] || !watchedValues[compareField]) return true;
    return dayjs(watchedValues[fieldName]).isBefore(dayjs(watchedValues[compareField]), 'day');
  },
};
